import { create } from 'zustand';

interface ReconRecord {
  id?: string;
  txn_date: string;
  ref: string;
  amount: number;
  description?: string;
  matched?: boolean;
}

interface ReconImport {
  id: string;
  name: string;
  status: 'pending' | 'processing' | 'complete' | 'failed';
  record_count: number;
  matched_count: number;
  unmatched_count: number;
}

interface ReconStore {
  currentImport: ReconImport | null;
  imports: ReconImport[];
  records: ReconRecord[];
  unmatchedRecords: ReconRecord[];
  setCurrentImport: (importRecord: ReconImport | null) => void;
  setImports: (imports: ReconImport[]) => void;
  setRecords: (records: ReconRecord[]) => void;
  setUnmatchedRecords: (records: ReconRecord[]) => void;
  updateImportStatus: (id: string, status: string, matched?: number, unmatched?: number) => void;
}

export const useReconStore = create<ReconStore>((set) => ({
  currentImport: null,
  imports: [],
  records: [],
  unmatchedRecords: [],
  setCurrentImport: (importRecord) => set({ currentImport: importRecord }),
  setImports: (imports) => set({ imports }),
  setRecords: (records) => set({ records }),
  setUnmatchedRecords: (records) => set({ unmatchedRecords: records }),
  updateImportStatus: (id, status, matched, unmatched) => set((state) => ({
    imports: state.imports.map(i => 
      i.id === id 
        ? { 
            ...i, 
            status: status as any, 
            matched_count: matched ?? i.matched_count,
            unmatched_count: unmatched ?? i.unmatched_count 
          } 
        : i
    ),
    currentImport: state.currentImport?.id === id 
      ? { 
          ...state.currentImport, 
          status: status as any,
          matched_count: matched ?? state.currentImport.matched_count,
          unmatched_count: unmatched ?? state.currentImport.unmatched_count
        }
      : state.currentImport,
  })),
}));
